module.exports = __webpack_public_path__ + "media/images/landing/persons/jolana-cermakova-ed436945cbe216852275bb363b096b7c.jpeg";